import { render, staticRenderFns } from "./AccessList.vue?vue&type=template&id=163aa4cd&scoped=true&lang=pug&"
import script from "./AccessList.vue?vue&type=script&lang=ts&"
export * from "./AccessList.vue?vue&type=script&lang=ts&"
import style0 from "./AccessList.vue?vue&type=style&index=0&id=163aa4cd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "163aa4cd",
  null
  
)

export default component.exports